import * as ng from 'angular';
import { ValidateNotEmpty } from '../../../../../services';
import { FormInputModelOptions } from '../../../../atoms/form-elements';

export class MoleculeInputTextOldPasswordController implements ng.IController {
    public static $inject: string[] = ['$translate'];

    public validationErrorList = [];
    public value: string;
    public placeholder: string;
    public callbackOnChange: (arg0: any) => any;
    public callbackOnBlur: (arg0: any) => any;
    public callbackOnBlurParams: any;
    public customCallbackOnEnter: () => {};
    public doNotSaveOnFormEnter: boolean;
    public disabled: boolean;
    public modelOptions: FormInputModelOptions;
    public registerToForm: boolean;
    public validationInstructions: any[];
    public options: any;
    public inputId: string;
    public callbackOnClear: (arg0: any) => any;
    public callbackOnClearParams: any;
    public clearable: boolean;

    constructor(
        private $translate: ng.translate.ITranslateService
    ) {}

    public $onInit() {
        this.validationInstructions = [
            {
                instructions: null,
                validator: new ValidateNotEmpty(this.$translate)
            }
        ];
        if (this.options != null && this.options !== undefined) {
            if (this.options.allowEmpty === true) {
                this.validationInstructions = [];
            }
        }
    }
    public hideCharacters = () => {
        if (this.options == null || this.options === undefined) {
            return true;
        }
        if (this.options.hideCharacters != null && this.options.hideCharacters !== undefined) {
            return this.options.hideCharacters;
        }
        return true;
    };

    public onPaste = (paste) => {
        // implement callback on paste here when needed!
    };
}

export class MoleculeInputTextOldPasswordComponent implements ng.IComponentOptions {
    public bindings = {
        callbackOnBlur: '<',
        callbackOnBlurParams: '<',
        callbackOnChange: '<',
        callbackOnClear: '<',
        callbackOnClearParams: '<',
        clearable: '<',
        customCallbackOnEnter: '<',
        disabled: '<',
        doNotSaveOnFormEnter: '<',
        inputId: '@?',
        modelOptions: '<',
        options: '<',
        placeholder: '@',
        registerToForm: '<',
        validationErrorList: '=?',
        value: '='
    };
    public controller = MoleculeInputTextOldPasswordController;
    public template = require('./input-text-with-validation-wrapper.html');
}
